export default __webpack_public_path__ + "static/media/result-fail.10c0d792.png";